import { createAction } from 'redux-starter-kit';

export const SET_WORKBENCHES = 'briefings/SET_WORKBENCHES';
export const CLEAR_WORKBENCHES = 'briefings/CLEAR_WORKBENCHES';
export const SET_WORKBENCH = 'briefings/SET_WORKBENCH';
export const CLEAR_WORKBENCH = 'briefings/CLEAR_BRIEFING';

export default {
  setWorkbenches: createAction(SET_WORKBENCHES),
  clearWorkbenches: createAction(CLEAR_WORKBENCHES),
  setWorkbench: createAction(SET_WORKBENCH),
  clearWorkbench: createAction(CLEAR_WORKBENCH),
};
